import {
  MdmInstalledApplicationsResolverActions,
  MdmInstalledApplicationsApiActions,
} from './mdm-installed-applications.actions';
import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { safeMap } from '../effects.helpers';

@Injectable()
export class MdmInstalledApplicationsEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDevicesService: AppleDevicesService
  ) {}

  mdmInstalledApplicationsRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(MdmInstalledApplicationsResolverActions.installedApplicationsRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDevicesService.getInstalledApplications(udid, '2.0'),
          (applications) =>
            MdmInstalledApplicationsApiActions.installedApplicationsLoaded({
              installedApplications: applications.map((app) => ({
                ...app,
                udid,
              })),
              udid,
            }),
          (error) => MdmInstalledApplicationsApiActions.installedApplicationsLoadedError({ error })
        )
      )
    );
  });
}
